import {type History} from 'history';

// The app router's history, for code outside React. Each app entry point sets
// it before its own startup call. Under the Forge shell the ARIA nav remote
// shares this module but has its own router, can run startup before the app
// mounts, and runs on pages where the app is not mounted; until the app sets a
// history, the browser's location is the only one available.
let globalHistory: History | undefined;

export function getGlobalHistory(): History | undefined {
  return globalHistory;
}

/** Sets the app's history; the returned function restores the previous one. */
export function setGlobalHistory(history: History): () => void {
  const previous = globalHistory;
  globalHistory = history;
  return () => {
    globalHistory = previous;
  };
}

/**
 * The pathname the app's routes match against. Under the Forge shell the
 * browser's pathname is the shell's (`/wandb/entity/...`), which they do not.
 */
export function getGlobalPathname(): string {
  return globalHistory?.location.pathname ?? window.location.pathname;
}
